import React, { FunctionComponent } from 'react';

import { LockedBagAddressStep as CommonLockedBagAddress } from 'scenes/common/components/Steps';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import { getLockedBoxAddress } from 'scenes/landlord/selectors';
import analytics from 'scenes/landlord/analytics';

const LockedBagAddressStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <CommonLockedBagAddress
    onNext={onNext}
    defaultStateValue={getLockedBoxAddress(funnelState)}
    onClickCallUs={() => analytics().callUs(funnelState)}
    onApiError={() => {}}
  />
);

export default LockedBagAddressStep;
